import { ready } from 'core-utilities';
import React from 'react';
import { render } from 'react-dom';
import Carousel from './containers/Carousel';
import PlayButton from './containers/PlayButton';
import AboutTab from './containers/AboutTab';
import carouselConstants from './constants/carouselConstants';
import playButtonConstants from './constants/playButtonConstants';
import aboutTabConstants from './constants/aboutTabConstants';

import '../../../css/gameDetails/gameDetails.scss';

ready(() => {
  if (carouselConstants.gameDetailsCarouselContainer()) {
    render(<Carousel />, carouselConstants.gameDetailsCarouselContainer());
  }

  if (playButtonConstants.gameDetailsPlayButtonContainer()) {
    render(<PlayButton />, playButtonConstants.gameDetailsPlayButtonContainer());
  }

  if (aboutTabConstants.gameDetailsAboutTabContainer()) {
    render(<AboutTab />, aboutTabConstants.gameDetailsAboutTabContainer());
  }
});
